import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PillarProvider } from './contexts/PillarContext';
import Header from './components/Header';
import LabPage from './pages/LabPage';
import HomePage from './pages/HomePage';
import ResultsPage from './pages/ResultsPage';
import ListingDetailPage from './pages/ListingDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProfilePage from './pages/ProfilePage';
import RatePage from './pages/RatePage';
import NewbuildPage from './pages/NewbuildPage';
import NewbuildProjectPage from './pages/NewbuildProjectPage';
import LabProfilePage from './pages/LabProfilePage';
import DatenschutzPage from './pages/DatenschutzPage';

const API_BASE = import.meta.env.VITE_API_URL || '';

function App() {
  // Load admin transparency settings and apply as CSS custom properties
  useEffect(() => {
    // Pillar 1 (Search) transparency
    fetch(`${API_BASE}/api/admin/transparency-settings`)
      .then(r => r.json())
      .then(res => {
        if (res.success && res.data) {
          const root = document.documentElement;
          Object.entries(res.data).forEach(([key, val]) => {
            root.style.setProperty(`--glass-${key}`, String(val));
          });
        }
      })
      .catch(() => { /* use CSS defaults */ });

    // Pillar 2 (Rate) transparency
    fetch(`${API_BASE}/api/admin/rate-transparency-settings`)
      .then(r => r.json())
      .then(res => {
        if (res.success && res.data) {
          const root = document.documentElement;
          Object.entries(res.data).forEach(([key, val]) => {
            root.style.setProperty(`--glass-${key}`, String(val));
          });
        }
      })
      .catch(() => { /* use CSS defaults */ });

    // Lab transparency
    fetch(`${API_BASE}/api/admin/lab-transparency-settings`)
      .then(r => r.json())
      .then(res => {
        if (res.success && res.data) {
          const root = document.documentElement;
          Object.entries(res.data).forEach(([key, val]) => {
            root.style.setProperty(`--glass-${key}`, String(val));
          });
        }
      })
      .catch(() => { /* use CSS defaults */ });

    // Pillar 3 (Newbuild) transparency
    fetch(`${API_BASE}/api/admin/newbuild-transparency-settings`)
      .then(r => r.json())
      .then(res => {
        if (res.success && res.data) {
          const root = document.documentElement;
          Object.entries(res.data).forEach(([key, val]) => {
            root.style.setProperty(`--glass-${key}`, String(val));
          });
        }
      })
      .catch(() => { /* use CSS defaults */ });
  }, []);

  return (
    <AuthProvider>
      <PillarProvider>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              {/* Lab – Father landing page (new homepage) */}
              <Route path="/" element={<LabPage />} />
              <Route path="/lab/profile" element={<LabProfilePage />} />
              {/* Pillar 1: SurrealEstateSearch */}
              <Route path="/search" element={<HomePage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/listing/:id" element={<ListingDetailPage />} />
              {/* Pillar 2: SurrealEstateRate */}
              <Route path="/rate" element={<RatePage />} />
              <Route path="/rate/profile" element={<ProfilePage />} />
              {/* Pillar 3: SurrealEstateNewbuild */}
              <Route path="/newbuild" element={<NewbuildPage />} />
              <Route path="/newbuild/project/:id" element={<NewbuildProjectPage />} />
              <Route path="/newbuild/profile" element={<ProfilePage />} />
              {/* Legal pages */}
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              {/* Shared routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Routes>
          </main>
        </div>
      </PillarProvider>
    </AuthProvider>
  );
}

export default App;
